import core from '@gin-betting/core';

const {
    hooks: { useDidUpdate, useMount },
} = core;

export { useMount, useDidUpdate };
export { default as usePromoItemContainer } from './usePromoItemContainer';
export { default as useOnClickOutside } from './useOnClickOutside';
export { default as useMemoSelector } from './useMemoSelector';
export { default as useUnmount } from './useUnmount';
export { default as usePrevious } from './usePrevious';
export { default as useToggler } from './useToggler';
export { default as usePureSelector } from './usePureSelector';
export { default as useCssClassToggleOnDocument } from './useCssClassToggleOnDocument';
export { default as useMouseEventsHandler } from './useMouseEventsHandler';
export { default as useWidgetSettings } from './useWidgetSettings';
export { default as useEventHandler } from './useEventHandler';
export { default as useWithLocation } from './useWithLocation';
export { default as useCheckOnRoute } from './useCheckOnRoute';
export { default as useAppliedFilters } from './useAppliedFilters';
export { default as useMore } from './useMore';
export { default as useForceUpdate } from './useForceUpdate';
